const limitString = (str,limit) => {
   
    return str.slice(0, limit) + (str.length > limit ? "..." : "");
}

export default limitString